import React, { useState, useRef } from 'react';
import { ButtonStyled, TextFieldStyled, useTokens } from '@nike/nike-design-system-components';
import { func, string, bool, array } from 'prop-types';
import { Box } from 'rebass';

import { trimNSplit } from '../../util/trim';

import Modal from '../../modal/Modal';
import BadgeStyled from '../../components/BadgeStyled';

const SearchSoldTosModal = ({ title, closeModal, isOpen, setSoldToFilterList, accounts }) => {
  const [inputValue, setInputValue] = useState('');
  const [soldTos, setSoldTos] = useState([]);

  const tokens = useTokens();
  const soldTosContainer = useRef();

  const clearInput = () => {
    setInputValue('');
    setSoldTos([]);
  };

  const close = () => {
    closeModal();
    clearInput();
  };

  const enterSoldTos = e => {
    e.preventDefault();
    const deduped = new Set(soldTos.concat(trimNSplit(inputValue)));
    setSoldTos([...deduped]);
    setInputValue('');
    const element = soldTosContainer.current;
    setTimeout(() => {
      element.scrollTop = element.scrollHeight;
    }, 10);
  };

  const onSoldTosInputChange = e => {
    setInputValue(e.target.value);
  };

  const content = ({ isLoading }) => {
    const isTextFieldDisabled = isLoading || inputValue.length === 0;

    const removeSoldTo = soldTo => () => {
      const filtered = soldTos.filter(number => number !== soldTo);
      setSoldTos(filtered);
    };

    return (
      <>
        <Box
          style={{ maxHeight: '390px', overflowY: 'scroll', width: '100%' }}
          ref={soldTosContainer}
          id='soldTosContainer'
        >
          {soldTos.map(
            (soldTo, index) =>
              soldTo && (
                <div style={{ width: '40%' }} key={soldTo}>
                  <BadgeStyled
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${soldTo}-${index}`}
                    text={soldTo}
                    block
                    onClose={removeSoldTo(soldTo)}
                    borderRadius='50px'
                    backgroundColor={tokens.podiumCdsColorBlack}
                    fontColor={tokens.podiumCdsColorWhite}
                  />
                </div>
              )
          )}
        </Box>

        <Box width='100%' mt='20px'>
          <form onSubmit={enterSoldTos} data-testid='searchSoldTos-form'>
            <TextFieldStyled
              name='searchSoldTos'
              id='searchSoldTos'
              label="Sold-To's"
              supportText='Paste a list of sold-to numbers (separated by spaces).'
              value={inputValue}
              onChange={onSoldTosInputChange}
              error={false}
              disabled={isTextFieldDisabled}
              autoComplete='off'
            />
          </form>
        </Box>
      </>
    );
  };

  const footer = ({ isLoading, toggleIsLoading }) => {
    const handleSubmit = async () => {
      toggleIsLoading(true, 'Searching Sold-Tos...');

      const accountIds = soldTos.map(soldTo => accounts.find(account => account.number === soldTo)?.id || null);
      setSoldToFilterList(accountIds.join(','));

      clearInput();

      toggleIsLoading(false);
      closeModal();
    };

    return (
      <ButtonStyled
        data-testid='addSoldTos-submit-button'
        type='button'
        appearance='primary'
        background='light'
        size='small'
        className='mt7-sm'
        onClick={handleSubmit}
        disabled={isLoading || soldTos.length === 0}
      >
        {`Search for ${soldTos.length} Sold-Tos`}
      </ButtonStyled>
    );
  };

  return <Modal title={title} content={content} footer={footer} isOpen={isOpen} closeModal={close} unwrapped />;
};

SearchSoldTosModal.propTypes = {
  title: string.isRequired,
  closeModal: func.isRequired,
  isOpen: bool.isRequired,
  setSoldToFilterList: func.isRequired,
  accounts: array.isRequired
};

export default SearchSoldTosModal;
